<section class="ai-chat-multi-select" [attr.aria-label]="question">
  <p *ngIf="question" class="question">
    <fastr-ui-streaming-text
      *ngIf="animateQuestion; else settledQuestion"
      [text]="question"></fastr-ui-streaming-text>
    <ng-template #settledQuestion>{{ question }}</ng-template>
  </p>

  <div class="options">
    <button
      *ngFor="let option of options; trackBy: trackByOptionId"
      type="button"
      class="option"
      [class.selected]="isSelected(option)"
      [disabled]="isOptionDisabled(option)"
      [attr.aria-pressed]="isSelected(option)"
      (click)="toggleOption(option)">
      <span class="checkbox" [class.checked]="isSelected(option)">
        <mat-icon *ngIf="isSelected(option)">check</mat-icon>
      </span>
      <span class="option-label">{{ option.label }}</span>
    </button>
  </div>

  <fastr-ui-ai-chat-custom-value
    *ngIf="allowCustomValue"
    [(value)]="customValue"
    [placeholder]="customValuePlaceholder"
    [showVoiceIcon]="showVoiceIcon"
    (submitted)="submit()">
  </fastr-ui-ai-chat-custom-value>

  <fastr-ui-ai-chat-actions
    [showSecondaryActions]="showSecondaryActions"
    [reviewAndSearchLabel]="reviewAndSearchLabel"
    [refineLabel]="refineLabel"
    [continueLabel]="continueLabel"
    [showBackAction]="showBackAction"
    [reviewAndSearchDisabled]="isReviewAndSearchDisabled()"
    [refineDisabled]="isRefineDisabled()"
    [continueDisabled]="!canSubmit()"
    (reviewAndSearch)="submitReviewAndSearch()"
    (refine)="submitRefine()"
    (backed)="submitBack()"
    (continued)="submit()">
  </fastr-ui-ai-chat-actions>
</section>
